// extracted by mini-css-extract-plugin
module.exports = {"customPadding":"styles_customPadding__3B7F3","selectorWrp":"styles_selectorWrp__JsXzn","loaderWrp":"styles_loaderWrp__32JPT"};